import React from 'react';
import { ResidencesList } from '../../components/Views/ResidencesPage';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import { residencesQuery } from '../../api/queries';
import { getStaticData } from '../../utils/helpers/getStaticData';
import { ResidenceSort } from '../../graphql/types';
import { getSSRContextData } from '../../utils/helpers/ssrContext';
import { withBugsnagGetServerSideProps } from '../../utils/withBugsnag';
import { readMockFile } from '../../utils/helpers/readMockFile';

const Residences = props => <ResidencesList {...props} />;

export const getServerSideProps = withBugsnagGetServerSideProps(
  async ({ res, req, query }) => {
    const { platform } = getSSRContextData(req);
    const currentLang = getLocaleOnSSR(req);

    const apolloClient = initApollo({}, { lang: currentLang, platform });
    const asPath = '/yasayis-kompleksleri';

    const sort = query.sort
      ? String(query.sort).toUpperCase()
      : ResidenceSort.DateDesc;

    if (
      (query.mock === 'true' || process.env.NEXT_PUBLIC_E2E === '1') &&
      process.env.NODE_ENV !== 'production'
    ) {
      const mock = await readMockFile('residencesMockData.json');

      return {
        props: { residences: mock.data.residences, hasError: false, sort }
      };
    }

    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=86400'
    );

    const isMapView = query.residences_view === 'map';

    const [seoData, residencesRes, staticData] = await Promise.all([
      getSeoData(apolloClient, asPath, req, true),
      apolloClient.query({
        query: residencesQuery,
        variables: { sort },
        skip: isMapView
      }),
      getStaticData(apolloClient)
    ]);

    return {
      props: {
        seoData,
        ...staticData,
        residences: residencesRes?.data?.residences || [],
        hasError: false,
        sort,
        currentLang
      }
    };
  },
  '/residences',
  context => {
    const currentLang = getLocaleOnSSR(context.req);

    return {
      seoData: {},
      keywords: [],
      citiesUnPopularList: [],
      regions: {},
      residences: [],
      hasError: true,
      currentLang
    };
  }
);

Residences.getLayout = (page, pageProps) => (
  <Layout
    isBottomNavigation
    isShowCloseButton={false}
    pageProps={pageProps}
    hideMobileHeader
  >
    {page}
  </Layout>
);

export default Residences;
